export default class CookieManager {
	static get(name) {
		const cookies = document.cookie.split('; '); // cookieを取得
		const cookieName = name + '='; // cookie名
		const cookie = cookies.find(c => c.startsWith(cookieName)); // cookie名が一致するものを取得
		return cookie ? decodeURIComponent(cookie.split('=')[1]) : null; // cookieがあればデコードして返す
	}

	// cookieの値を設定
	static set(name, value, expiresDays, path = '/', domain = document.domain, secure = false, samesite = 'Lax') {
		let cookieStr = `${name}=${encodeURIComponent(value)}`;

		// 有効期限を設定
		if (expiresDays) {
			const expiresDate = new Date();
			expiresDate.setDate(expiresDate.getDate() + expiresDays); // 有効期限の日数を設定
			cookieStr += `;expires=${expiresDate.toUTCString()}`; // 有効期限を設定
		}

		// pathを設定
		cookieStr += `;path=${path}`;
		// domainを設定
		if (domain) cookieStr += `;domain=${domain}`;
		// secureを設定
		if (secure) cookieStr += ';secure';
		// samesiteを設定
		if (samesite) cookieStr += `;samesite=${samesite}`;

		// cookieを設定
		document.cookie = cookieStr;
	}

	// cookieの値を削除
	static del(name, path = '/', domain = document.domain) {
		let cookieStr = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`; // 有効期限を過去に設定
		cookieStr += `;path=${path};domain=${domain}`; // pathとdomainを設定
		document.cookie = cookieStr;
	}
}